module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-type-epigraph element-without-heading",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "epigraph-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-right"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("Yes, yours, my love, is the right human "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("face")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("I in my mind had waited for this "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("long")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("Seeing the false and searching for the "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("true")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("Then found you as a traveller finds a "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("place")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("Of welcome suddenly amid the "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("wrong")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("Valleys and rocks and twisting roads. But "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("you")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("What shall I call you? A fountain in a "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("waste")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("A well of water in a country "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("dry")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("Or anything that’s honest and good, an "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("eye")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("That makes the whole world bright. Your open "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("heart")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("Simple with giving, gives the primal "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("deed")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("The first good world, the blossom, the blowing "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("seed")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("The hearth, the steadfast land, the wandering "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("sea")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("Not beautiful or rare in every "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("part")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("But like yourself, as they were meant to "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("be")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-right"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("THE CONFIRMATION by Edwin "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Muir")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("15 May 1887 – 3 January "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("1959")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08274547","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/epigraph.vue
// module id = 78
// module chunks = 0